module.exports = __webpack_public_path__ + "static/img/sc19.6fc891b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc19.png
// module id = oG8L
// module chunks = 25